export const commons = {
  loaderTxt: 'Cargando',
  continueBtn: 'Continuar',
  backBtn: 'Volver',
  acceptBtn: 'Aceptar',
  cancelBtn: 'Cancelar',
  saveBtn: 'Guardar',
  finishBtn: 'Finalizar',
  overwriteBtn: 'Sobrescribir',
  required: '*',
  requiredFields: 'Campos obligatorios',
  newRecipient: 'Nuevo destinatario',
  select: 'Seleccionar',
  send: 'Enviar'
};

export const homeTxt = {
  title: name => `Hola ${name}, ¿qué necesitas?`,
  verHistorico: 'Histórico de envío de certificados',
  bajaRetenciones:
    'Envío de certificados a personal que ha causado baja que haya trabajado durante 2021',
  altaRetenciones:
    'Envío de certificados a personal de alta que haya trabajado durante 2021',
  buscarEmpleado: 'Enviar certificado a un empleado',
  verHistoricoBtn: 'Consultar',
  ocultarHistoricoBtn: 'Ocultar',
  bajaRetencionesBtn: 'Baja',
  altaRetencionesBtn: 'Alta',
  buscadorRetencionesBtn: 'Buscar',
  scheduleCollection: 'Programar recogida',
  scheduleCollectionBtn: 'RECOGIDA',
  createShipment: 'Crear nuevo envío',
  createShipmentBtn: 'CREAR ENVÍO',
  shippingList: 'Ver todos los envíos',
  shippingListBtn: 'VER ENVÍOS',
  tooltip:
    'Programar la recogida de un paquete en una dirección “x” y traerlo a las oficinas de Atresmedia.'
};

export const requestedByTxt = {
  title: 'Enviar la solicitud en nombre de:',
  scheduleCollection: 'Programar recogida',
  inputTitle: 'Seleccionar otro usuario:',
  inputLabel: 'NOMBRE',
  placeholder: 'Envíar en nombre de:'
};

export const chooseDestinyTxt = {
  title: 'Selecciona el destino',
  description:
    'Si vas a realizar envíos a más de una dirección, selecciona “Varios destinos”.',
  radioButton1: 'España',
  radioButton2: 'Resto del mundo',
  toggleLabel: 'Varios destinos',
  toggleInfo: '(Masivo/Etapas)',
  required: '*',
  obligatedFields: 'Campos obligatorios',
  radioBoxName: 'destiny',
  radioBoxValue1: 'españa',
  radioBoxValue2: 'internacional'
};

// txt 05-E-UNICO-DESTINO / 10-E-ETAPAS / 19-E-RECOGIDA
export const destinyDataShippingTxt = {
  title: 'Indica los datos de destino',
  receiverInputLabel: 'Empresa/Destinatario',
  contactNameInputLabel: 'Nombre contacto',
  startingPersonNameLabel: 'Empresa',
  endingPersonNameLabel: 'Destinatario',
  directionInputLabel: 'Dirección',
  directionInputDataLabel: 'Dirección (Datos adicionales)',
  CPInputLabel: 'C.P.',
  cityInputLabel: 'Ciudad',
  phoneInputLabel: 'Teléfono',
  required: '*',
  obligatedFields: 'Campos obligatorios',
  countryDropdownLabel: 'País',
  companyNameAutocompleteName: 'companyName',
  personNameInputName: 'personName',
  addressAutocompleteName: 'address',
  addressAdditionalName: 'addressAdditional',
  address1InputName: 'address1',
  address2InputName: 'address2',
  zipCodeInputName: 'zipCode',
  zipCodeInputNameSender: 'zipCodeSender',
  zipCodeInputNameReceiver: 'zipCodeReceiver',
  cityInputName: 'city',
  cityInputSenderName: 'citySender',
  cityInputReceiverName: 'cityReceiver',
  phoneNumberInputName: 'phoneNumber',
  phoneNumberSenderInputName: 'phoneSenderNumber',
  phoneNumberReceiverInputName: 'phoneReceiverNumber',
  fromTo: 'Salida del paquete',
  sendTo: 'Llevar a',
  receiverName: 'Destinatario',
  observationsInputName: 'comments',
  observationsText: 'Observaciones',
  addOtherAddress: 'Añadir otra dirección',
  returnToOrigin: 'Retornar a origen',
  tooltip: 'Traer el paquete de vuelta a la dirección de salida.',
  spainScope: 'españa',
  spainCode: '724',
  internationalScope: 'internacional',
  titleSchedule: 'Indica los datos de recogida',
  subtitleSchedule1: 'Recoger el paquete en',
  subtitleSchedule2: 'Traer a'
};

// txt 09-E-MASIVO-DETALLE
export const MultipleRecipients = {
  title: 'Destinatarios',
  btnAnyadir: 'Añadir destinatario'
};

// txt 09-E-MASIVO-DETALLE (FormRecipient)
export const formRecipientTxt = {
  NoRecipientNameTxt: 'Nuevo destinatario',
  inputLabel1: 'Empresa/Destinatario',
  inputId1: 'empresaDestinatario',
  inputLabel2: 'Nombre de contacto',
  inputId2: 'nombreContacto',
  inputLabel3: 'Dirección',
  inputId3: 'direccion',
  inputLabel4: 'Dirección (Datos adicionales)',
  inputId4: 'direccionAdicionales',
  inputLabel5: 'C.P.',
  inputId5: 'cp',
  inputLabel6: 'Ciudad',
  inputId6: 'ciudad',
  inputLabel7: 'Teléfono',
  inputId7: 'telefono',
  labelDropdown: 'País',
  observations: 'Observaciones'
};

// txt 11-E-SOBRES-PAQUETES
export const setWrappingShippingTxt = {
  title: '¿Qué quieres enviar?',
  radioButton1: 'sobres',
  radioButton2: 'paquetes',
  radioLeyend1: 'Tamaño máximo 36cm x 26cm',
  radioLeyend2: 'Caja/sobre superior a 36cm x 26cm',
  radioBoxName: 'wrapping-type',
  quantityTitle: '¿Cuántos son?',
  quantityInputLabel: 'Cantidad',
  quantityInputId: 'inputNumber',
  required: '*',
  simpleType: 'simple',
  complexType: 'complex',
  internationalScope: 'internacional',
  complexMultiple: 'multiple',
  obligatedFields: 'Campos obligatorios'
};

// txt 13-E-DESCRIPCION-INTERNACIONAL
export const setInternationalDescriptionTxt = {
  title: 'Descripción de los articulos a enviar',
  textareaId: 'internationalDescription',
  textareaLabel: 'Describe tu envío..',
  toggleLabel: 'Son documentos',
  required: '*',
  obligatedFields: 'Campos obligatorios'
};

export const setImputationTxt = {
  title: 'Descripción de los articulos a enviar',
  label: 'Describe tu envío..',
  radioButton2: 'Paquetes',
  required: '*',
  obligatedFields: 'Campos obligatorios'
};

// txt 14-E-ASEGURAR
export const asegurarTxt = {
  title: '¿Necesitas asegurarlo?',
  radioButton1: 'no asegurar',
  radioButton2: 'asegurar',
  description: 'Descripción',
  value: 'Valor',
  placeholder: 'DESCRIPCIÓN DE LA MERCANCÍA A ASEGURAR',
  inputLabel: 'VALOR MERCANCÍA',
  inputId: 'inputValue',
  percent: 66.6,
  breadcrumbsTitle: 'Tu solicitud hasta ahora:'
};

// txt 18-E-PROFORMA
export const proformaTxt = {
  toggleLabel:
    '¿Quieres adjuntar una factura proforma indicando el contenido del sobre y su valor?',
  title: 'Factura proforma',
  donwloadText: 'Descargar modelo factura proforma',
  donwloadSubText: '(Recuerda que la proforma debe estar sellada y firmada)'
};

// txt 20-E-MASIVO-ETAPAS
export const chooseComplexShippingTxt = {
  title: '¿Que tipo de envío es?',
  radioButton1: 'Envío masivo',
  radioButton1Value: 'multiple',
  radioButton2: 'Envío con etapas',
  radioButton2Value: 'phased',
  radioBoxName: 'complexType',
  tooltipTitle1: 'Envío masivo',
  tooltipTxt1: 'Envíos de varios bultos a varios destinos',
  tooltipTitle2: 'Envío con etapas',
  tooltipTxt2:
    'Envío de una misma mercancía de una direción a otra con posibilidad de retorno al origen'
};

// txx 22-E-URGENTE
export const urgentTxt = {
  title: '¿Es un envío urgente?',
  optionUrgentTxt: 'Es urgente',
  optionNoUrgentTxt: 'No es urgente',
  radioUrgentName: 'urgente',
  priorityMail: '1',
  notPriorityMail: '0',
  envelop: 'sobres',
  complexShipping: 'complex'
};

export const insuranceTxt = {
  title: '¿Necesitas asegurarlo?',
  insuranceYes: 'Asegurar',
  insuranceNo: 'No asegurar',
  descriptionPlaceholder: 'Descripción de la mercancía a asegurar',
  merchandiseValueLabel: 'Valor de la mercancía',
  radioBoxName: 'seguro',
  radioBoxValue1: 'insureNo',
  radioBoxValue2: 'insureYes',
  valuePlaceholder: '€',
  valueInputId: 'inputValue'
};

// 24-E-HORARIO-NACIONAL
export const selectScheduleTxt = {
  title: '¿En qué horario quieres que llegue?',
  radioSchedulesName: 'horario',
  options: {
    ASM24: 'A lo largo del día siguiente',
    ASM14: 'Antes de las 14:00 del día siguiente',
    ASM10: 'Antes de las 10:00 del día siguiente',
    PICKUP_ON_SATURDAY: 'Entrega en sábado',
    DELIVERY_ON_WAREHOUSE: 'Recogida en nave',
    SEUR1: 'SEUR antes 10:00',
    SEUR2: 'SEUR día siguiente',
    EXPRESS1: 'EXPRESS 9:00 (34,23€)',
    EXPRESS2: 'EXPRESS 12:00 (14,23€)',
    EXPRESS_WORLDWIDE: 'EXPRESS WORLDWIDE (9,23€)'
  },
  envelop: 'sobres',
  simpleType: 'simple'
};

export const modalCancelTxt = {
  titleEmoji: '¡Cuidado!',
  buttonTxt: 'Sí, quiero cancelar',
  messageTxt:
    'Si cancelas el proceso se perderán todos los datos de esta solicitud.',
  questionTxt: '¿Estás seguro que quieres cancelar?',
  emotion: 'sorpresa'
};

// 25-E-BUSCAR-IMPUTACIÓN
export const modalImputationSearchTxt = {
  title: 'Buscar',
  inputlabel1: 'Nombre/Código',
  selectLabel1: 'Sociedad',
  th1: 'Nombre',
  th2: 'Código'
};

// txt 30-E-RESUMEN
export const confirmRequestTxt = {
  title: 'Confirma los datos y finaliza la solicitud',
  sectionTitle_1: 'Envío',
  sectionTitle_2: 'Imputación',
  sectionTitle_3: 'Destinatario',
  sectionTitle_3_alt: 'Destinatarios',
  sectionTitle_4: 'Autorizador',
  sectionTitle_4_alt: 'Autorizadores',
  sectionTitle_5: 'Emisor',
  sectionTitle_7: 'Observaciones',
  buttonAnyadirTxt: 'Añadir observación',
  sectionTitle_6: 'Extensión de contacto',
  alertTxt: '*Debes indicar tu extensión de contacto',
  options_schedule: {
    ASM24: 'Día siguiente',
    ASM14: '14:00 día siguiente',
    ASM10: '10:00 día siguiente',
    PICKUP_ON_SATURDAY: 'Entrega sábado',
    DELIVERY_ON_WAREHOUSE: 'Recogida nave',
    SEUR1: 'SEUR antes 10:00',
    SEUR2: 'SEUR día siguiente'
  },
  insured: 'Seguro',
  express: 'Urgente',
  complexShipping: 'complex',
  complexMultiple: 'multiple',
  complexPhased: 'phased',
  madrid: 'Madrid',
  spain: 'España',
  international: 'Internacional'
};

// txt 31-E-ANADIR-EXTENSION
export const modalExtensionTxt = {
  titleEmoji: 'Añadir extensión',
  inputLabel: 'Número de extensión',
  inputId: 'numero_de_extension',
  inputName: 'extension'
};

// txt 31-E-ANADIR-OBSERVACION
export const modalObservationTxt = {
  title: 'Añadir observaciones',
  textareaLabel: 'Observaciones',
  textareaId: 'numero_de_extension',
  textareaName: 'observations'
};

// txt 33-E-SOLICITUD-RESUMEN
export const shippingStatus = {
  shippingStatusPending: 'Solicitud pendiente de autorizar',
  shippingStatusPendingSecondary:
    'Recibirás una notificación cuando tu solicitud haya sido autorizada.',
  shippingStatusApproved: 'Solicitud de envío completada',
  shippingStatusApprovedSecondary:
    'Ahora sólo falta que entregues los bultos en paquetería.',
  shippingStatusRejected: 'Solicitud de envío rechazada',
  shippingBtnPrint: 'Imprimir etiqueta',
  shippingTitle: 'Envío',
  imputationTitle: 'Imputación',
  addresseeTitle: 'Destinatario',
  addresseesTitle: 'Destinatarios',
  authorizerTitle: 'Autorizador',
  authorizersTitle: 'Autorizadores',
  obsTitle: 'Observaciones',
  extTitle: 'Extensión de contacto',
  shippingBtnInit: 'Ir a inicio',
  insured: 'Seguro',
  express: 'Urgente',
  recipients: 'destinatarios',
  seeAll: 'Ver todos',
  saveDisabled: 'Ya existe una direción con este nombre'
};

export const breadcrumbTxt = {
  destiny: {
    national: 'España',
    international: 'Resto del mundo'
  },
  title: 'Tu solicitud hasta ahora:',
  insurance: 'Seguro',
  urgent: 'Urgente',
  multiple: 'Masivo',
  schedule: 'Recogida',
  phased: 'Etapas'
};

export const shipmentDestinationTxt = {
  madrid: 'MADRID',
  canary: 'CANARY_ISLANDS',
  ceuta: 'CEUTA',
  melilla: 'MELILLA',
  balearic: 'BALEARIC_ISLANDS',
  spain: 'SPAIN',
  ue: 'EUROPEAN_UNION',
  outUe: 'OUTSIDE_EU',
  undefined: 'UNDEFINED'
};

export const masiveMultipleTxt = {
  title: 'Indica los datos de destino',
  description:
    'Puedes subir un archivo con todos los destinatarios, o introducirlos manualmente',
  addButton: 'Añadir destinatario',
  donwloadText: 'Descargar plantilla destinatarios',
  setTotalAddressees: total => `${total} destinatarios`
};

// Modales

export const modalRequestRecipients = {
  titleModalSaveRecipient: 'Guardar destinatario',
  ModalOverwrite_title: 'Confirmar acción',
  ModalOverwrite_text: 'Ya existe un usuario',
  ModalOverwrite_textStrong:
    '¿Quieres sobrescribir los datos o guardar un nuevo destinatario?',
  titleModalAllRecipients: 'Todos los destinatarios',
  titleModalSaveSuccesfull: 'Dirección guardada',
  ModalSaveSuccesfull_text: 'La dirección se ha guardado correctamente.'
};

export const modalDHL = {
  titleModal: 'Selecciona el servicio de DHL',
  descriptionModal: 'Este es un envío internacional.',
  descriptionModal1:
    'Para validar la solicitud primero debes seleccionar el servicio de DHL que quieres asignarle.',
  descriptionModal2:
    'A continuación pulsa el botón “Validar” que aparece en la solicitud para grabarla en el proveedor.'
};

export const modalTracking = {
  titleModal: 'Detalles'
};

export const modalReasonRefuse = {
  titleModal: '¿Porqué rechazas la solicitud?',
  descriptionModal: 'Debes indicar al usuario el motivo del rechazo.',
  labelTextarea: 'Otros motivos'
};

export const error404 = {
  title: 'ERROR',
  number1: '4',
  number2: '4',
  msj: 'El contenido al que intentas acceder no ha sido encontrado',
  button: 'Ir a Inicio'
};

// txt 35-GUARDAR-DIRECCIÓN
export const saveContactTxt = {
  title: 'Guardar destinatario',
  receiverInputLabel: 'Empresa/Destinatario',
  contactNameInputLabel: 'Nombre contacto',
  directionInputLabel: 'Dirección',
  directionInputLabelOne: 'Dirección 1',
  directionInputLabelTwo: 'Dirección 2',
  directionInputDataLabel: 'Dirección (Datos adicionales)',
  CPInputLabel: 'C.P.',
  cityInputLabel: 'Ciudad',
  phoneInputLabel: 'Teléfono',
  countryDropdownLabel: 'País',
  companyNameAutocompleteName: 'companyName',
  addressAutocompleteName: 'address',
  address1InputName: 'address1',
  address2InputName: 'address2',
  zipCodeInputName: 'zipCode',
  cityInputName: 'city',
  phoneNumberInputName: 'phoneNumber'
};

// 36-E-VARIOS-DESTINATARIOS
export const severalRecipients = {
  title: 'Todos los destinatarios'
};

export const ModalAuthorizerInsuredTxt = {
  title: 'Autorizador',
  txt1:
    'Por tratarse de un envío especial (asegurado y/o urgente) esta solicitud tiene que ser validada.',
  txt2: 'Y recuerda...',
  txtList1:
    'En caso de siniestro tendrás que presentar la factura de compra para poder reclamar el seguro.',
  txtList2: 'Sólo se admitirán paquetes correctamente embalados y protegidos.'
};

export const routesTxt = {
  pathCreateShipping: '/create_shipping',
  promptMsg: 'Se perderán los cambios, ¿Está seguro?'
};

// txt 03-G-LISTADO-SOLICITUDES

export const shipmentListTxt = {
  shipmentListTitle: 'Listado de solicitudes',
  shipmentListSubtitle: 'Solicitudes autorizadas y/o pendientes de autorizar.',
  autoCompleteLabel: 'Solicitante',
  autoCompletePlaceHolder: 'Nombre del solicitante...',
  autoCompleteLabelCreator: 'Destinatario',
  autoCompletePlaceHolderCreator: 'Nombre del destinatario...',
  dropdownLabel: 'Estado Solicitud',
  inputLabel: 'Imputación',
  inputPlaceHolder: 'Código de imputación',
  inputDateLabel: 'Fecha solicitud',
  inputDatePlaceHolder: '- - / - - / - -',
  iconFill: 'white',
  minus: '-',
  plus: '+',
  firstToogleLabel: 'Iniciadas por mi',
  secondToogleLabel: 'Pendientes de mi acción',
  firstTableHeader: role =>
    role === 'creator' ? 'destinatario' : 'solicitante',
  secondTableHeader: 'fecha',
  thirdTableHeader: 'estado',
  fourthTableHeader: 'destino',
  fifthTableHeader: 'tipo',
  sixthTableHeader: 'cantidad',
  seventhTableHeader: 'imputación',
  formattedData: 'DD/MM/YYYY',
  creatorRole: 'creator',
  adminRole: 'admin',
  validatorPaqueteria: 'Paquetería',
  validatorSSGG: 'SS.GG.',
  statusOptions: {
    CANCELLED_BY_USER: 'Cancelada',
    CANCELLED_BY_STAFF: 'Anulada',
    REJECTED: 'Rechazada',
    VALIDATED_BY_PARCEL_STAFF: 'Validada',
    SENT: 'Completada',
    DELIVERED: 'Entregado',
    AUTHORIZED: 'Pendiente',
    PENDING: 'Pendiente',
    AUTHORIZE_PENDING: 'Pendiente',
    VALIDATE_PENDING_SSGG: 'Pendiente',
    VALIDATED_BY_GENERAL_SERVICES: 'Pendiente',
    VALIDATE_PENDING_PARCEL_STAFF: 'Pendiente'
  },
  scheduleOptions: {
    ASM24: 'Día siguiente',
    ASM14: 'Antes 14hs',
    ASM10: 'Antes 10hs',
    PICKUP_ON_SATURDAY: 'Sábado',
    DELIVERY_ON_WAREHOUSE: 'Recogida nave'
  },
  destinationOptions: {
    MADRID: 'LOCAL',
    CANARY_ISLANDS: 'NACIONAL',
    CEUTA: 'NACIONAL',
    MELILLA: 'NACIONAL',
    BALEARIC_ISLANDS: 'NACIONAL',
    SPAIN: 'NACIONAL',
    EUROPEAN_UNION: 'INTERNACIONAL',
    OUTSIDE_EU: 'INTERNACIONAL',
    UNDEFINED: 'UNDEFINED'
  },
  unavailable: 'No aplicable',
  emptyDate: '---',
  afirmative: 'Sí',
  negative: 'No',
  dropdownStatusOptions: [
    {
      value: 0,
      label: 'Anulada',
      status: ['CANCELLED_BY_STAFF']
    },
    {
      value: 1,
      label: 'Cancelada',
      status: ['CANCELLED_BY_USER']
    },
    {
      value: 2,
      label: 'Completada',
      status: ['SENT']
    },
    {
      value: 3,
      label: 'Entregado',
      status: ['DELIVERED']
    },
    {
      value: 4,
      label: 'Pendiente',
      status: [
        'AUTHORIZED',
        'PENDING',
        'AUTHORIZE_PENDING',
        'VALIDATE_PENDING_SSGG',
        'VALIDATED_BY_GENERAL_SERVICES',
        'VALIDATE_PENDING_PARCEL_STAFF'
      ]
    },
    {
      value: 5,
      label: 'Rechazada',
      status: ['REJECTED']
    },
    {
      value: 6,
      label: 'Validada',
      status: ['VALIDATED_BY_PARCEL_STAFF']
    }
  ],
  expandedRow: {
    idTitle: 'ID',
    validatorTitle: 'Validador',
    deliveryTimeTitle: 'Franja horaria',
    priorityMailTitle: 'Urgente',
    authorizerTitle: 'Autorizador',
    insuredTitle: 'Asegurado'
  }
};

// txt 06-G-DETALLE-SOLICITUDES

export const shipmentDetailTxt = {
  titleDetail: 'Detalle de la solicitud ',
  requester: 'Solicitante',
  refusal: 'Motivo rechazo',
  refusalDescription: 'Detalle',
  onBehalfOf: 'En nombre de ',
  characteristics: 'Características del envío',
  currency: '€',
  reject: 'Rechazar',
  validate: 'Validar',
  edit: 'Editar',
  generalInformation: 'Información General',
  date: 'Fecha',
  id: 'ID',
  requestState: 'Estado solicitud',
  extension: 'Extensión',
  imputation: 'Imputación',
  deliveryPlace: 'Destino',
  type: 'Tipo',
  quantity: 'Cantidad',
  insurance: 'Seguro',
  urgent: 'Urgente',
  service: 'Servicio',
  destinataries: 'Destinatarios',
  destinatariesDescription: 'Destinatario de prueba',
  authorizerValidator: ' Autorizador / Validador',
  authorizerTitle: ' Autorizador',
  authorizerDescription: 'Nombres hardcoded',
  validatorTitle: 'Validador',
  providerTitle: 'Transportista',
  providerCompany: 'Compañía',
  providerTrackingId: 'Tracking ID',
  observationsTitle: 'Observaciones',
  observationDescription: ' Observaciones hardcoded',
  historial: 'Historial',
  exit: 'Salir',
  editExit: 'Salir del modo edición',
  save: 'Guardar',
  cancel: 'Cancelar',
  destinationOptions: {
    MADRID: 'Local',
    CANARY_ISLANDS: 'Nacional',
    CEUTA: 'Nacional',
    MELILLA: 'Nacional',
    BALEARIC_ISLANDS: 'Nacional',
    SPAIN: 'Nacional',
    EUROPEAN_UNION: 'Internacional',
    OUTSIDE_EU: 'Internacional',
    UNDEFINED: 'UNDEFINED'
  },
  packetOptions: {
    ENVELOPE: 'Sobre',
    PACKET: 'Paquete'
  },
  packetQuantity: amount => (amount === 1 ? 'unidad' : 'unidades'),
  authorizer: {
    authorizers: ['string'],
    validators: 'Servicios Generales'
  },
  carrierInfo: {
    isEditable: true,
    provider: 'DHL',
    time: 'ASM10',
    trackingNumbers: ['string']
  },
  generalInfo: {
    applicantName: 'Sami Ali Delgado',
    creationDate: '12/07/18',
    extension: '38909',
    id: '5b3505f07ed1a8758ca5ad7d',
    imputation: 'CECO',
    imputationNumber: '73890',
    shipmentStatus: 'Pendiente (SS.GG.)'
  },
  history: {
    historyItem: [
      {
        date: '2018-11-12T08:15:08.369Z',
        description: 'string',
        status: 'string'
      }
    ]
  },
  shipmentInfo: {
    addressees: [
      {
        address: 'string',
        address2: 'string',
        addresseeId: 'string',
        city: 'string',
        comments: 'string',
        companyName: 'string',
        country: 'string20px',
        personName: 'string',
        phoneNumber: 'string',
        zipCode: 'string'
      }
    ],
    deliveryTime: 'ASM10',
    deliveryTimeDescription: 'string',
    insured: 'Si',
    insuredAmount: 0,
    isEditable: true,
    packetType: 'Sobres',
    priorityMail: 'Urgente',
    quantity: 86,
    shipmentDestination: 'Madrid',
    shippingType: 'SINGLE'
  }
};
